import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CatalogOverviewPageComponent } from '@htx/catalog';

@NgModule({
  declarations: [],
  imports: [CommonModule, CatalogOverviewPageComponent],
  exports: [CatalogOverviewPageComponent]
})
export class OverviewModule {}
